document.addEventListener('change', event => {
  if (event.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details.mobile-nav[open]').forEach(details => {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
});

document.addEventListener('click', event => {
  document.querySelectorAll('details.mobile-nav[open]').forEach(details => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

// Keep in-page navigation reliable on mobile. A same-page Pumpenfinder link used
// to leave the open menu panel on top of the destination, which made the click
// appear to do nothing even though the browser had moved to the correct anchor.
function closeMobileNavigation() {
  document.querySelectorAll('details.mobile-nav[open]').forEach(details => {
    details.removeAttribute('open');
  });
}

function scrollToPumpFinder(behavior = 'auto') {
  const finder = document.getElementById('pumpenfinder');
  if (!finder) return false;

  finder.scrollIntoView({ behavior, block: 'start' });
  finder.focus({ preventScroll: true });
  return true;
}

document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link) return;

  if (link.closest('.mobile-nav')) closeMobileNavigation();

  let destination;
  try {
    destination = new URL(link.href, window.location.href);
  } catch (_error) {
    return;
  }

  const samePage = destination.origin === window.location.origin
    && destination.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

  if (!samePage || destination.hash !== '#pumpenfinder') return;
  if (!document.getElementById('pumpenfinder')) return;

  event.preventDefault();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${destination.hash}`);
  window.requestAnimationFrame(() => scrollToPumpFinder(reducedMotion ? 'auto' : 'smooth'));
});

function restorePumpFinderHash() {
  if (window.location.hash !== '#pumpenfinder') return;
  window.requestAnimationFrame(() => scrollToPumpFinder('auto'));
}

window.addEventListener('pageshow', restorePumpFinderHash);
document.addEventListener('shopify:section:load', restorePumpFinderHash);

// Restore Shopify country/address defaults when customer forms are rendered.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('select[data-default]').forEach(select => {
    const desired = select.dataset.default;
    if (!desired) return;
    const option = [...select.options].find(item => item.value === desired || item.text === desired);
    if (option) select.value = option.value;
  });
});


document.querySelectorAll('[data-pd-first-page]').forEach(link => { const url = new URL(window.location.href); url.searchParams.delete('page'); link.href = url.toString(); });
